import { render, staticRenderFns } from "./CustomRoaming.vue.html?vue&type=template&id=12b382ea&lang=html&external"
import script from "./CustomRoaming.vue.js?vue&type=script&lang=js&external"
export * from "./CustomRoaming.vue.js?vue&type=script&lang=js&external"
import style0 from "./CustomRoaming.vue.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports